<template>
    <div class="info-board-container">
        <div class="info-board">
            <p class="text" v-html="tower.text"></p>
            <div class="opts">
                <a :href="link" target="_blank">
                    <a-button icon="caret-right" type="primary">开始游戏</a-button>
                </a>
                <a :href="`${link}${tower.name}.zip`" target="_blank">
                    <a-button icon="download">下载游戏</a-button>
                </a>
            </div>
            <div v-if="tower.publisher.id != -1">
                <h3>发布者</h3>
                <user-tag :user="tower.publisher"></user-tag>
            </div>
            <div>
                发布时间: {{ tower.uploadtime }} |
                更新时间: {{ formatTime(Number(tower.createtime)+15) }}
            </div>
            <div>
                <h3>标签</h3>
                <a-tag v-for="tag of tags" :key="tag">{{ tag }}</a-tag>
            </div>
            <div>
                <h3>相似的塔</h3>
                <tower-tag
                    v-for="similarTower of tower.similarTowers"
                    :key="similarTower.name"
                    v-bind="similarTower"
                />
            </div>
            <div v-if="showPlaytime">
                <h3>游玩时长分布</h3>
                <dispatch-bar :data="tower.playtime" />
            </div>
        </div>
    </div>
</template>

<script>
import Title from '@/components/Title.vue'
import UserTag from '@/components/UserTag.vue';
import TowerTag from '@/components/TowerTag.vue';
import DispatchBar from '../components/DispatchBar.vue';
import { formatTime } from '../../../utils/utils';

export default {
    props: {
        tower: Object
    },
    computed: {
        tags() {
            const tags = this.tower.tag.split("|");
            if (tags[tags.length-1] == "") tags.pop();
            return tags;
        },
        link() {
            if (!this.tower.link.endsWith("/")) {
                return this.tower.link + '/';
            }
            return this.tower.link;
        },
        showPlaytime() {
            return this.tower.playtime.reduce((r, e) => r + e) > 0;
        }
    },
    methods: {
        formatTime,
    },
    components: {
        Title,
        UserTag,
        TowerTag,
        DispatchBar,
    }
}
</script>

<style lang="less" scoped>
.info-board-container {
    text-align: left;
}
.info-board {
    margin-left: 10px;
    div {
        margin: 10px 0;
    }
}
.opts {
    a + a {
        margin-left: 30px;
    }
}
.text {
    font-size: 16px;
}
</style>